import { render, staticRenderFns } from "./SemtelBanner.vue?vue&type=template&id=05c8edd0&scoped=true&"
import script from "./SemtelBanner.vue?vue&type=script&lang=js&"
export * from "./SemtelBanner.vue?vue&type=script&lang=js&"
import style0 from "./SemtelBanner.vue?vue&type=style&index=0&id=05c8edd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8edd0",
  null
  
)

export default component.exports